module.exports = __webpack_public_path__ + "img/12_20.10291aaa.png";